import { Breeder } from 'dogpark/types';

export interface BreedersState {
  loading: boolean;
  breeders: Breeder[];
  fetchBreeders: boolean;
}

export const breedersInitState: BreedersState = {
  loading: false,
  breeders: [],
  fetchBreeders: true,
};

export type BreedersAction =
  | { type: 'LOAD_BREEDERS' }
  | { type: 'SET_BREEDERS'; payload: { breeders: Breeder[] } }
  | { type: 'SET_FETCH_BREEDERS' };

export const breedersReducer = (
  state: BreedersState,
  action: BreedersAction,
): BreedersState => {
  switch (action.type) {
    case 'LOAD_BREEDERS': {
      return { ...state, loading: true };
    }
    case 'SET_BREEDERS': {
      const { breeders } = action.payload;
      return { ...state, breeders, loading: false, fetchBreeders: false };
    }
    case 'SET_FETCH_BREEDERS': {
      return { ...state, fetchBreeders: true, breeders: [] };
    }
  }
};
